import "./index.scss";
import { DSButton } from "components/UI/atoms";
import { ReactComponent as DollarSign } from "assets/dollar.svg";

export const Playground = () => {
  // Icon to use in buttons

  // Button variations
  const buttonTypes = ["primary", "secondary", "outlined", "ghost"];
  const buttonSizes = ["xlarge", "large", "default", "small", "xsmall"];
  const iconPositions = ["left", "right", null];
  const disabledStates = [true, false];

  return (
    <div className="playground-container">
      {/* H1 Section */}
      <div className="typography-container">
        <p className="typography-title">H1 Typography</p>
        <h1 className="sm-web-bold">H1 Small Bold</h1>
        <h1 className="md-web-bold">H1 Medium Bold</h1>
        <h1 className="lg-web-bold">H1 Large Bold</h1>
      </div>

      {/* H2 Section */}
      <div className="typography-container">
        <p className="typography-title">H2 Typography</p>
        <h2 className="sm-web-md">H2 Small Medium</h2>
        <h2 className="sm-web-bold">H2 Small Bold</h2>
        <h2 className="md-web-md">H2 Medium Medium</h2>
        <h2 className="md-web-bold">H2 Medium Bold</h2>
        <h2 className="lg-web-md">H2 Large Medium</h2>
        <h2 className="lg-web-bold">H2 Large Bold</h2>
      </div>

      {/* H3 Section */}
      <div className="typography-container">
        <p className="typography-title">H3 Typography</p>
        <h3 className="sm-web-md">H3 Small Medium</h3>
        <h3 className="sm-web-bold">H3 Small Bold</h3>
        <h3 className="md-web-md">H3 Medium Medium</h3>
        <h3 className="md-web-bold">H3 Medium Bold</h3>
        <h3 className="lg-web-md">H3 Large Medium</h3>
        <h3 className="lg-web-bold">H3 Large Bold</h3>
      </div>

      {/* H4 Section */}
      <div className="typography-container">
        <p className="typography-title">H4 Typography</p>
        <h4 className="sm-web-md">H4 Small Medium</h4>
        <h4 className="sm-web-bold">H4 Small Bold</h4>
        <h4 className="md-web-md">H4 Medium Medium</h4>
        <h4 className="md-web-bold">H4 Medium Bold</h4>
        <h4 className="lg-web-md">H4 Large Medium</h4>
        <h4 className="lg-web-bold">H4 Large Bold</h4>
      </div>

      {/* Body Section */}
      <div className="typography-container">
        <p className="typography-title">Body Typography</p>
        <div className="body-sm-web-reg">Body Small Regular</div>
        <div className="body-sm-web-md">Body Small Medium</div>
        <div className="body-md-web-reg">Body Medium Regular</div>
        <div className="body-md-web-md">Body Medium Medium</div>
        <div className="body-lg-web-reg">Body Large Regular</div>
        <div className="body-lg-web-md">Body Large Medium</div>
      </div>

      {/* Captions Section */}
      <div className="typography-container">
        <p className="typography-title">Captions Typography</p>
        <div className="cap-sm-web-reg">Caption Small Regular</div>
        <div className="cap-sm-web-md">Caption Small Medium</div>
        <div className="cap-md-web-reg">Caption Medium Regular</div>
        <div className="cap-md-web-md">Caption Medium Medium</div>
        <div className="cap-lg-web-reg">Caption Large Regular</div>
        <div className="cap-lg-web-md">Caption Large Medium</div>
      </div>

      {/* Input Section */}
      <div className="typography-container">
        <p className="typography-title">Input Typography</p>
        <div className="input-sm-web-reg">Input Small Regular</div>
        <div className="input-sm-web-md">Input Small Medium</div>
        <div className="input-sm-web-bold">Input Small Bold</div>
        <div className="input-md-web-reg">Input Medium Regular</div>
        <div className="input-md-web-md">Input Medium Medium</div>
        <div className="input-md-web-bold">Input Medium Bold</div>
        <div className="input-lg-web-reg">Input Large Regular</div>
        <div className="input-lg-web-md">Input Large Medium</div>
        <div className="input-lg-web-bold">Input Large Bold</div>
      </div>

      {/* Example with solid border */}
      <div className="solid-border">
        <p>Solid Border</p>
      </div>

      {/* Example with dashed border */}
      <div className="dashed-border">
        <p>Dashed Border</p>
      </div>

      {/* Button */}
      <div className="button-container">
        {buttonTypes.map((type) =>
          buttonSizes.map((size) =>
            iconPositions.map((position) =>
              disabledStates.map((disabled) => (
                <div
                  className="playground__button-wrapper"
                  key={`${type}-${size}-${position}-${disabled}`}
                >
                  <DSButton
                    variant={type}
                    size={size}
                    disabled={disabled}
                    {...(position && {
                      icon: <DollarSign />,
                      iconPosition: position
                    })}
                  >
                    {`${type.charAt(0).toUpperCase() + type.slice(1)} ${size} ${
                      disabled ? "(Disabled)" : ""
                    }`}
                  </DSButton>
                </div>
              ))
            )
          )
        )}
      </div>

      {/* Grid Testing Section */}
      <div className="grid">
        <div className="col-xs-4 col-sm2-4 col-sm1-6 col-md-8 col-lg-12 col-xlg-6">
          Item 1
        </div>
        <div className="col-xs-2 col-sm2-2 col-sm1-3 col-md-4 col-lg-6 col-xlg-6">
          Item 2
        </div>
        <div className="col-xs-2 col-sm2-2 col-sm1-3 col-md-4 col-lg-6 col-xlg-6">
          Item 3
        </div>
      </div>

      <div className="logo-container">
        <div className="logo-preview">
          <div className="logo-preview__title">Logotipo (Light)</div>
          <div className="logo-preview__container logotipo-light"></div>
        </div>

        <div className="logo-preview">
          <div className="logo-preview__title">Logotipo (Dark)</div>
          <div className="logo-preview__container logotipo-dark"></div>
        </div>

        <div className="logo-preview">
          <div className="logo-preview__title">Simbol (Light)</div>
          <div className="logo-preview__container simbol-light"></div>
        </div>

        <div className="logo-preview">
          <div className="logo-preview__title">Simbol (Dark)</div>
          <div className="logo-preview__container simbol-dark"></div>
        </div>

        <div className="logo-preview">
          <div className="logo-preview__title">Tagline (Light)</div>
          <div className="logo-preview__container tagline-light"></div>
        </div>

        <div className="logo-preview">
          <div className="logo-preview__title">Tagline (Dark)</div>
          <div className="logo-preview__container tagline-dark"></div>
        </div>
      </div>
    </div>
  );
};
